var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useId } from '../hooks';
import Label from './label';
import Steps from './steps';
import { progressStyle, progressWrapperStaticStyle, wrapperStyle, } from './styles';
function Progress(_a) {
    var { 'aria-label': ariaLabel, customLabel, hideLabel = false, inverted = false, max = 100, mode = 'continuous', size = 'medium', value = 0, variant = 'default' } = _a, restProps = __rest(_a, ['aria-label', "customLabel", "hideLabel", "inverted", "max", "mode", "size", "value", "variant"]);
    const progressId = `progress-${useId()}`;
    const isStepsMode = mode === 'steps';
    return (_jsxs("div", Object.assign({ css: wrapperStyle({ inverted, size }), "data-testid": "progress-wrapper" }, { children: [_jsxs("div", Object.assign({ css: progressWrapperStaticStyle }, { children: [isStepsMode && _jsx(Steps, { id: progressId, max: max, size: size }), _jsx("progress", Object.assign({ "aria-label": isStepsMode
                            ? ariaLabel.concat(' ', `${Math.floor(value)} out of ${max} steps`)
                            : ariaLabel, "aria-valuemax": max, "aria-valuemin": 0, "aria-valuenow": value, css: progressStyle({
                            clipId: `${progressId}-clip`,
                            size,
                            variant,
                        }), id: progressId, max: max, value: value }, restProps))] })), !hideLabel && (_jsx(Label, Object.assign({}, { customLabel, id: progressId, isStepsMode, max, value })))] })));
}
export default Progress;
